import { Component, h } from 'preact';
import { NBSP, Properties } from '../../common';
import { WithStyles, withStyles } from '../../style';
import * as styles from './FlagIcon.scss';
import { isPresent } from '../../utils';

export interface FlagIconProps extends Properties {
  countryCode: string;
}

@withStyles(styles)
export default class FlagIcon extends Component<FlagIconProps, any> {
  render({ countryCode, tx }: FlagIconProps & WithStyles): h.JSX.Element {
    const flagIcon: string = styles[`flag_${countryCode}`];
    return isPresent(flagIcon) ? (
      <i className={tx(this.props.class, 'flagIcon flagSmall', flagIcon)}>{NBSP}</i>
    ) : undefined;
  }
}
